/* This is the Firebase configuration file */

import Firebase from 'firebase'
import config from './config'

let app = Firebase.initializeApp(config)
let db = app.database()

if (location.hostname === 'localhost') {
  // Point to the RTDB emulator running on localhost.
  db.useEmulator('localhost', 9000)
}

// create a database references
const settingsRef = db.ref('settings')
const pagesRef = db.ref('pages')
const booksRef = db.ref('books')
const paramsRef = db.ref('params')
const textsRef = db.ref('texts')
const categoriesRef = db.ref('categories')
const featuredRef = db.ref('featured')
const authorsRef = db.ref('authors')
const postsRef = db.ref('feeds/podcast/items')
const usersRef = db.ref('users')
const mediaRef = db.ref('media')
const navRef = db.ref('nav')

export { paramsRef, booksRef, textsRef, featuredRef, categoriesRef, authorsRef, postsRef, usersRef, settingsRef, pagesRef, mediaRef, navRef }



// WEBPACK FOOTER //
// ./src/firebase_config/index.js